import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useGlobalContext } from "./data/GlobalContext"

const LiveChat = () => {
  const { username } = useGlobalContext()
  const location = useLocation()

  useEffect(() => {
    window.__lc = window.__lc || {}
    window.__lc.license = 11142882
    ;(function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n)
      }
      const e = {
        _q: [],
        _h: null,
        _v: "2.0",
        on: function () {
          i(["on", c.call(arguments)])
        },
        once: function () {
          i(["once", c.call(arguments)])
        },
        off: function () {
          i(["off", c.call(arguments)])
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            )
          return i(["get", c.call(arguments)])
        },
        call: function () {
          i(["call", c.call(arguments)])
        },
        init: function () {
          const s = t.createElement("script")
          s.async = true
          s.type = "text/javascript"
          s.src = "https://cdn.livechatinc.com/tracking.js"
          t.head.appendChild(s)
        },
      }

      if (!n.__lc.asyncInit) e.init()
      n.LiveChatWidget = n.LiveChatWidget || e
    })(window, document, [].slice)

    let isOpen = false
    let intervalId = null

    const getChatElement = () => {
      return document.querySelector("iframe[src*='livechatinc']")?.parentElement
    }

    const applyStyle = () => {
      const el = getChatElement()
      if (el) {
        el.style.bottom = isOpen ? "0px" : "130px"
        el.style.zIndex = "999999999"
      }
    }

    window.LiveChatWidget.on("ready", function () {
      if (username) {
        window.LiveChatWidget.call("set_customer_name", username)
      }

      window.LiveChatWidget.call("minimize")
      isOpen = false

      // 🔥 ALWAYS enforce position (this is the key fix)
      intervalId = setInterval(() => {
        applyStyle()
      }, 50) // fast but lightweight

      // 🔥 Sync state properly (no guessing)
      window.LiveChatWidget.on("visibility_changed", function (data) {
        isOpen = data.visibility === "maximized"
      })
    })

    return () => {
      if (intervalId) clearInterval(intervalId)

      const script = document.querySelector(
        'script[src="https://cdn.livechatinc.com/tracking.js"]'
      )
      if (script) script.remove()

      delete window.LiveChatWidget
    }
  }, [location, username])

  return null
}

export default LiveChat
